import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { PagedCrudService } from "@features/grid";
import { FileDetails } from "@main/file-storage";
import { DocumentType } from "@main/file-storage/document-type";
import { PatientService } from "@main/app-layout/components/patient-switch/patient.service";

@Injectable({
    providedIn: "root"
})
export class DocumentService extends PagedCrudService<FileDetails> {
    readonly url = "api/documents";
    entityTitle = "Document";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory, private patientService: PatientService) {
        super(http, handlersFactory);
    }

    upload(documentType: DocumentType, uploadDateTime: Date, files: File & {
        private: boolean
    }[]): Promise<FileDetails[]> {
        const formData = new FormData();
        formData.set("documentType", documentType.toString());
        formData.set("uploadDateTime", uploadDateTime.toISOString());
        if (this.patientService.currentPatientId) {
            formData.set("patientId", this.patientService.currentPatientId);
        }
        files.forEach((file, index) => {
            formData.append("files", file as any);
            if (file.private) {
                formData.append("privateFilesIndexes", index.toString());
            }
        });
        return this.handleRequest<FileDetails[]>(this.http.post<FileDetails[]>(`${this.url}/upload`, formData));
    }

    updatePrivateStatus(updatePrivateStatus: { id: string, private: boolean }[]): Promise<void> {
        return this.handleRequest<void>(this.http.post<any>(`${this.url}/update-private-status`, updatePrivateStatus));
    }

    checkForDuplicate(fileName: string, extension: string, size: number): Promise<boolean> {
        const params = {
            fileName: fileName.replace(extension, ""),
            extension: extension.toLowerCase(),
            size: size.toString()
        };

        return this.handleRequest<boolean>(
            this.http.get<boolean>(`${this.url}/check-duplicate`, { params })
        );
    }
}